import cloneDeep from 'clone-deep';
import {
    ORDER_TYPE_DATE_FILTERS,
    getStartAndEndDateFromOrderTypeDateFilter,
} from '../../constants/CommonUtil';
import { getEndOfDay, getStartOfDay } from '../../constants/DateUtil';
import {
    generateConstructFromFilterColumns,
    generateSearchFilterConstruct,
} from '../../components/GenericFilterComponent/GenericFilterComponentUtil';
import {
    COMBINEMODE,
    generateObjectWithCombineMode,
    generateObjectWithCriteriaMode,
    getCombined,
} from '../../sagas/util';
import {
    invoiceTypes,
} from '../RegistrationAppComponents/QuickRegistration/QuickRegistrationForm/QuickRegistrationFormUtil';
import { getStringFromObject } from '../../constants/lodashUtils';

export const invoiceSearchTypes = {
    INVOICE: 'INVOICE',
    PATIENT: 'PATIENT',
};

export const invoiceNumberSearchFieldFilter = [
    {
        name: 'account_invoice.number',
        filterOperation: '=',
    },
];

export const invoicePatientSearchFieldFilters = [
    {
        name: 'res_partner.ref',
        filterOperation: '=',
    },
];

export const insuranceInvoiceTableFilter = () => ([
    {
        name: 'datePeriod',
        type: 'dateRange',
        label: 'Period',
        valueField: 'key',
        disableClear: true,
        showOnTop: true,
        grid: '3',
        options: Object.keys(ORDER_TYPE_DATE_FILTERS).map(aPeriod => ({
            key: aPeriod,
            value: ORDER_TYPE_DATE_FILTERS[aPeriod],
        })),
        defaultOption: {
            key: 'LAST_5_DAYS',
            value: 'Past 5 Days',
        },
    },
    {
        name: 'account_invoice.state',
        type: 'select',
        label: 'State',
        valueField: 'key',
        disableClear: true,
        options: [
            {
                key: 'draft',
                value: 'DRAFT',
            },
            {
                key: 'open',
                value: 'OPEN',
            },
            {
                key: 'paid',
                value: 'PAID',
            },
            {
                key: 'cancel',
                value: 'Cancel',
            },
        ],
        searchConstructFields: {
            name: 'account_invoice.state',
            filterOperation: '=',
        },
    },
]);

export const hasInsuranceInvoiceSearchText = (filters = {}, searchText) => {
    const text = (searchText || getStringFromObject('searchText', filters, '')).trim();
    return text.length > 0;
};

export const getDefaultInvoiceFilters = () => {
    const {
        startDate,
        endDate,
    } = getStartAndEndDateFromOrderTypeDateFilter(ORDER_TYPE_DATE_FILTERS.LAST_5_DAYS);
    return {
        searchType: invoiceSearchTypes.PATIENT,
        datePeriod: {
            startDate,
            endDate,
            period: ORDER_TYPE_DATE_FILTERS.LAST_5_DAYS,
        },
    };
};

const getPaymentTypeSearchConstruct = () => {
    let paymentTypeConstruct = generateObjectWithCombineMode(generateObjectWithCriteriaMode(
        'account_invoice.paymentType',
        invoiceTypes.INSURANCE,
        '=',
    ), 'OR', generateObjectWithCriteriaMode(
        'account_invoice.paymentType',
        invoiceTypes.CREDIT,
        '=',
    ));
    paymentTypeConstruct = generateObjectWithCombineMode(generateObjectWithCriteriaMode(
        'account_invoice.paymentType',
        invoiceTypes.CORPORATE,
        '=',
    ), 'OR', paymentTypeConstruct);
    return paymentTypeConstruct;
};

const getDateFilterConstruct = (filters) => {
    const datePeriod = getStringFromObject('datePeriod', filters) ||
        getStartAndEndDateFromOrderTypeDateFilter(ORDER_TYPE_DATE_FILTERS.LAST_10_DAYS);
    const {
        startDate,
        endDate,
    } = datePeriod;
    if (startDate && endDate) {
        return getCombined(
            generateObjectWithCriteriaMode(
                'account_invoice.dateInvoice',
                getStartOfDay(startDate).getTime(),
                '>=',
            ),
            COMBINEMODE.AND,
            generateObjectWithCriteriaMode(
                'account_invoice.dateInvoice',
                getEndOfDay(endDate).getTime(),
                '<=',
            ),
        );
    }
    if (startDate) {
        return generateObjectWithCriteriaMode(
            'account_invoice.dateInvoice',
            getStartOfDay(startDate).getTime(),
            '>=',
        );
    }
    if (endDate) {
        return generateObjectWithCriteriaMode(
            'account_invoice.dateInvoice',
            getEndOfDay(endDate).getTime(),
            '<=',
        );
    }
    return null;
};

export const getInvoiceListSearchConstruct = (filters, searchText) => {
    const cloneFilters = cloneDeep(filters || {});
    const {
        searchType,
    } = cloneFilters;
    delete cloneFilters.searchType;
    delete cloneFilters.searchText;

    let searchFilterSchema = invoiceNumberSearchFieldFilter;
    const textToSearch = (searchText || '').trim();
    if (searchType === invoiceSearchTypes.PATIENT) {
        searchFilterSchema = invoicePatientSearchFieldFilters;
    }

    const dateFilterConstruct = getDateFilterConstruct(cloneFilters);
    delete cloneFilters.datePeriod;

    const filterConstruct = generateConstructFromFilterColumns(insuranceInvoiceTableFilter(), cloneFilters);
    const searchValueConstruct = generateSearchFilterConstruct(textToSearch, searchFilterSchema);

    let searchConstruct = getCombined(filterConstruct, COMBINEMODE.AND, searchValueConstruct);
    searchConstruct = getCombined(searchConstruct, COMBINEMODE.AND, dateFilterConstruct);
    searchConstruct = getCombined(searchConstruct, COMBINEMODE.AND, getPaymentTypeSearchConstruct());
    return searchConstruct;
};
